import api from './api';



export const saveFcmToken = async (token) => {
  const response = await api.post('/api/users/fcm-token', { token });
  return response.data;
};

export const getUserProfile = async () => {
  const response = await api.get('/api/users/me');
  return response.data;
};

export const getUserHistory = async () => {
    const response = await api.get('/api/users/history');
    return response.data;
};

export const removeSkill = async (skillId) => {
    const response = await api.delete(`/api/users/skills/${skillId}`);
    return response.data;
};

export const updateFCMToken = async (token) => {
    const response = await api.post('/api/users/fcm-token', { token });
    return response.data;
};

export const clearUserHistory = async () => {
    const response = await api.delete('/api/users/history/clear');
    return response.data;
};

export const getUserSkills = async () => {
    const response = await api.get('/api/users/skills');
    return response.data;
};

export const updateUserSkills = async (skills) => {
    const response = await api.post('/api/users/skills', { skills });
    return response.data;
};
